// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"32049998","270":"9fe8b048","285":"0962298a","479":"89878e5c","742":"b37520f7","791":"2bc94f24","891":"729d638f"}[chunkId] + ".chunk.css";
};